// extracted by mini-css-extract-plugin
export default {"head":"Admin_head__OQw9h","withMenu":"Admin_withMenu__ssEw4","main":"Admin_main__++XN6","content":"Admin_content__jYYKs"};